import Vue from 'vue'

export default {
    clearUser(state) {
        Vue.set(state, 'newInvitation', {})
    },
    setInvitation(state, invitation){
        Vue.set(state, 'invitation', invitation)
    }
}
